import SecureLS from "secure-ls";
import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// IMPORTACAO DOS MODULOS
import campos from './modules/campos';
import aplicacoes from './modules/aplicacoes';
import auth from './modules/auth';
import cidades from './modules/cidades';
import erros from './modules/erros';
import formularios from './modules/formularios';
import grupos from './modules/grupos';
import instituicao from './modules/instituicao';
import membros from './modules/membros';
import modalLateral from './modules/modalLateral';
import regionais from './modules/regionais';
import turmas from './modules/turmas';
import unidades from './modules/unidades';
import municipios from "./modules/municipios";
import notificacao from "./modules/notificacao";
import devolutivas from "./modules/devolutivas";

const ls = new SecureLS({ isCompression: false });


export default createStore({
  modules: [
    campos,
    aplicacoes, 
    auth,
    cidades,
    erros, 
    formularios,
    grupos,
    instituicao,
    membros,
    modalLateral,
    turmas,
    unidades,
    regionais,
    municipios,
    notificacao,
    devolutivas
  ],
  plugins: [
    createPersistedState({
      // paths: [""], // PERMITE O SALVAMENTO DOS ESTADOS EM CACHE CRIPTOGRAFADO
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    })
  ]
});